
import http from 'utils/request'
import Host from './apiHostConfig'
const { get, post } = http

export interface apiConfig {
  [key: string]: {
    url: string
    method?: 'get' | 'post'
    host?: string
    headerType?: 'form' | 'json'
  }
}
export interface apiFun {
  [key: string]: any
}

const generateApiFun = (apiConfigList: apiConfig): apiFun => {
  const listFun: apiFun = {}
  for (const key in apiConfigList) {
    const method = apiConfigList[key].method ?? 'get'
    const host = apiConfigList[key].host ?? 'rbox'
    const url = Host[host] + apiConfigList[key].url
    if (method === 'get') {
      listFun[key] = async (params = {}) => {
        return await get(url, params)
      }
    }
    if (method === 'post') {
      listFun[key] = async (data: { [key: string]: any } = {}) => {
        let config = {}
        if (apiConfigList[key].headerType && apiConfigList[key].headerType === 'form') {
          config = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          }
        } else {
          config = {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }
        }

        return await post(url, {}, data, config)
      }
    }
  }
  return listFun
}
export default generateApiFun
